import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSystemInnerList } from '@/api/message';
// import OrgSelect from "@/components/Org/OrgSelect";
import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr, saveFile } from '@/utils/index';
import delDialog from '@/components/System/DelDialog';
import manage from '@/constants/manage';
export default {
  components: {
    NoData: NoData,
    delDialog: delDialog
  },
  data: function data() {
    var validatePass2 = function validatePass2(rule, value, callback) {
      var reg = new RegExp('^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$');
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的邮箱号'));
      }
    };
    return {
      defaultProps: {
        label: 'orgName',
        children: 'children',
        isLeaf: function isLeaf(data) {
          if (data.isChildren) {
            return false;
          } else {
            return false;
          }
        }
      },
      dataTree: [],
      rules: {
        userName: [{
          required: true,
          message: '请输入用户名称',
          trigger: 'blur'
        }],
        userId: [{
          validator: function validator(rule, value, callback) {
            if (/[\u4E00-\u9FA5]/g.test(value)) {
              callback(new Error('请勿输入中文'));
            } else {
              // 校验通过
              callback();
            }
          },
          trigger: 'blur'
        }, {
          required: true,
          message: '请输入用户编号',
          trigger: 'blur'
        }],
        // pathName:[
        //         {required:true,message:'请选择机构',}
        //     ],
        // jobCode:[
        //         {required:true,message:'请选择职位名称',trigger: 'change' }
        //     ],
        mail: [{
          required: true,
          validator: validatePass2,
          trigger: 'blur'
        }]
      },
      editInforules: {
        userName: [{
          required: true,
          message: '请选择系统名称',
          trigger: 'change'
        }],
        jobCodeList: [{
          required: true,
          message: '请输入职位',
          trigger: 'change'
        }],
        telephone: [{
          required: true,
          message: '请输入联系方式',
          trigger: 'blur'
        }],
        userStatus: [{
          required: true,
          message: '请选择用户状态',
          trigger: 'change'
        }]
      },
      rulesEdit: {
        systemId: [{
          required: true,
          message: '请选择系统名称',
          trigger: 'change'
        }],
        roleName: [{
          required: true,
          message: '请选择角色名称',
          trigger: 'change'
        }],
        roleId: [{
          validator: function validator(rule, value, callback) {
            if (/[\u4E00-\u9FA5]/g.test(value)) {
              callback(new Error('请勿输入中文'));
            } else {
              // 校验通过
              callback();
            }
          },
          trigger: 'blur'
        }],
        corner: [{
          required: true,
          message: '请选择角色',
          trigger: 'change'
        }]
      },
      input: '',
      tableData: [],
      showUser: false,
      userInfo: [{
        title: '用户编号',
        code: 'userId'
      }, {
        title: '用户名',
        code: 'userName'
      }, {
        title: '所属机构',
        code: 'pathName'
      }, {
        title: '职位',
        code: 'jobList'
      }, {
        title: '联系方式',
        code: 'telephone'
      }, {
        title: '用户状态',
        code: 'userStatus'
      }, {
        title: '机构编号',
        code: 'branch'
      }, {
        title: '职级',
        code: 'mngLevel'
      }, {
        title: '条线',
        code: 'busLinCode'
      }],
      selectItem: {},
      orgOptions: [],
      configureData: [],
      showSetting: false,
      value: '',
      permissionList: [],
      roleOrgList: [],
      pageshow: true,
      resourceVOList: [],
      resourceProps: {
        label: 'resourceName',
        children: 'children',
        isLeaf: false
      },
      showOrgDialog: false,
      orgSelectList: '',
      jobList: [],
      editInfo: {},
      showUserDialog: false,
      showAddUserDialog: false,
      synchronization: false,
      newUserInfo: {
        branch: '',
        jobCodeList: '',
        orgId: '',
        pathName: '',
        telephone: '',
        userId: '',
        userOrd: '',
        userName: '',
        userStatus: 'VALID',
        mail: '',
        systemId: '',
        mngLevel: '',
        // 职级
        buslinCode: '' // 条线
      },

      userSettingName: '',
      orgDialogOptions: [],
      pageSize: 10,
      pageNum: 1,
      orgDialogValue: '',
      loading: false,
      DialogSystemName: '',
      DialogRoleName: '',
      configUserId: '',
      userManageName: '',
      userManageId: '',
      editPermisiongForm: {
        userName: '',
        userId: '',
        roleName: '',
        corner: '',
        orgPathName: [],
        systemId: '',
        roleId: ''
      },
      editPermissions: false,
      systemList: [],
      roleList: [],
      delChecked: false,
      total: 0,
      dataOrgId: '',
      ifShowDelDialog: false,
      selectNode: '',
      changeOrgData: '',
      selectData: [],
      userOrgChange: false,
      showTable: false,
      fingureLoading: false,
      configTitle: '新增用户角色权限配置',
      isIndeterminate: false,
      isshowdependOrg: false,
      tableheight: 0,
      isgetJobed: false,
      orgErr: false,
      openList: [],
      dictInfo: {},
      mngList: [],
      buslinList: [],
      dictList: JSON.parse(sessionStorage.getItem('dist_info')),
      mngInfo: {},
      manageLoading: false,
      manageList: [],
      editOrgPath: [],
      userStatus: 'VALID',
      topId: manage.HEAD_ORG_ID,
      test: ''
    };
  },
  watch: {
    editPermisiongForm: {
      handler: function handler(newVal) {
        if (newVal.roleName !== '' && newVal.roleName.dependOrg === 1) {
          this.isshowdependOrg = true;
        } else {
          this.isshowdependOrg = false;
        }
      },
      deep: true
    },
    userManageName: {
      handler: function handler() {}
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 350;
      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 350;
      };
    });
  },
  created: function created() {
    var _this = this;
    this.dictInfo = this.dictList.BUSINESS_LINE || null;
    this.mngInfo = this.dictList.MANAGER_LEVEL || null;
    var obj = this.dictInfo;
    if (this.dictInfo !== null) {
      // eslint-disable-next-line guard-for-in
      for (var i in obj) {
        this.buslinList.push({
          key: i,
          value: obj[i]
        });
      }
    }
    obj = this.mngInfo;
    if (this.mngInfo !== null) {
      // eslint-disable-next-line guard-for-in
      for (var _i in obj) {
        this.mngList.push({
          key: _i,
          value: obj[_i]
        });
      }
    }
    this.$API.getRequest({
      url: '/platform/systemInner/list'
    }).then(function (res) {
      if (res.code === '0000000000') {
        // eslint-disable-next-line array-callback-return
        res.result.records.filter(function (item) {
          var selectvalue = {
            value: item.systemId,
            label: item.systemName
          };
          _this.systemList.push(selectvalue);
        });
      }
    });
    this.getInit();
    this.searchForm();
    getSystemInnerList().then(function (res) {
      _this.orgOptions = res.result.records;
    });
    //  this.getJobList()
  },

  methods: {
    exportFile: function exportFile() {
      var _this2 = this;
      this.$API.getRequest({
        url: '/platform/user/exportUserList',
        data: {
          userId: this.userManageId.trim(),
          userName: this.userManageName.trim(),
          userStatus: this.userStatus
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          if (!res.result.filePath) {
            _this2.$message({
              message: '文件已缓存，请稍后到消息中下载',
              type: 'success'
            });
          } else {
            _this2.$API.getRequest({
              url: '/platform/file/templateDownload',
              data: {
                filePath: res.result.filePath
              },
              responseType: 'blob'
            }).then(function (res) {
              saveFile(res.data, '用户信息.xlsx');
            });
          }
        }
      });
    },
    getOrg: function getOrg() {
      var _this3 = this;
      this.$API.getRequest({
        url: '/platform/org/getOrgByOrgIdOrOrgName',
        data: {
          orgId: this.orgDialogValue,
          orgName: '',
          pageNum: '',
          pageSize: ''
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.dataTree = res.result.records;
        }
      });
    },
    getLevelInfo: function getLevelInfo(list) {
      var name = '';
      list.forEach(function (ele) {
        name = "".concat(name + ele.jobName, "/").concat(ele.jobCode, "  ");
      });
      return name;
    },
    getManageLevel: function getManageLevel(query) {
      var _this4 = this;
      if (query !== '') {
        this.manageLoading = true;
        this.$API.getRequest({
          url: '/platform/job/jobName',
          data: {
            pageSize: 5,
            pageNum: 1,
            jobName: query
          }
        }).then(function (res) {
          _this4.manageLoading = false;
          if (res.code === '0000000000') {
            _this4.manageList = res.result.map(function (ele) {
              return {
                jobCode: "".concat(ele.jobName, "/").concat(ele.jobCode),
                jobName: "".concat(ele.jobName, "/").concat(ele.jobCode)
              };
            });
          }
        });
      } else {
        this.options = [];
      }
    },
    getSub: function getSub(options) {
      // 获取选中的绑定部门
      this.editPermisiongForm.orgPathName = options;
    },
    topSeach: function topSeach() {
      this.pageNum = 1;
      this.searchForm();
    },
    delRole: function delRole() {
      var _this5 = this;
      var data = [];
      if (this.selectData.length === 0) {
        this.$message({
          message: '请选择需要删除的用户！',
          type: 'warning'
        });
        return;
      }
      this.selectData.forEach(function (ele) {
        data.push(ele.userId);
      });
      this.$API.delRequest({
        url: '/platform/user',
        data: data
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this5.$message({
            message: '删除成功',
            type: 'success'
          });
          if (_this5.pageNum === Math.ceil(_this5.total / _this5.pageSize) && (_this5.total % _this5.pageSize === data.length || _this5.total % _this5.pageSize === 0)) {
            _this5.pageNum > 1 ? _this5.pageNum-- : _this5.pageNum = 1;
          }
          _this5.searchForm();
        }
        _this5.ifShowDelDialog = false;
      });
    },
    submitOrgDialog: function submitOrgDialog() {
      var _this6 = this;
      if (this.userOrgChange) {
        this.newUserInfo.pathName = this.orgSelectList;
        this.showOrgDialog = false;
        return;
      }
      var data = {
        orgId: this.selectNode.orgId,
        userId: this.changeOrgData.row.userId
      };
      this.$API.putRequest({
        url: '/platform/user/org',
        data: data
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this6.$message({
            message: '修改成功',
            type: 'success'
          });
          _this6.showOrgDialog = false;
          if (_this6.dataOrgId === '') {
            _this6.searchForm();
          } else {
            _this6.getCurrentNode(_this6.dataOrgId);
          }
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      // const checkedCount = val.length
      // this.delChecked = checkedCount === this.tableData.length
      // this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length
      this.selectData = val;
    },
    getSelectRow: function getSelectRow() {},
    // selectAll(checked) {
    //   if (checked) {
    //     this.tableData.forEach((ele) => {
    //       this.$refs.multipleTable.toggleRowSelection(ele, true)
    //     })
    //   } else {
    //     this.$refs.multipleTable.clearSelection()
    //   }
    //   this.isIndeterminate = false
    // },
    sizeChange: function sizeChange(num) {
      this.pageSize = num;
      if (this.dataOrgId === '') {
        this.searchForm();
      } else {
        this.getCurrentNode(this.dataOrgId);
      }
    },
    currentChange: function currentChange(page) {
      this.pageNum = page;
      if (this.dataOrgId === '') {
        this.searchForm();
      } else {
        this.getCurrentNode(this.dataOrgId);
      }
    },
    delUser: function delUser() {
      if (this.selectData.length > 0) {
        this.ifShowDelDialog = true;
      }
    },
    delUserInfo: function delUserInfo(scope) {
      var _this7 = this;
      var page = Math.ceil(this.total / this.pageSize); // 最大页数
      if (this.pageNum === page) {
        // if(this.total%this.pageSize == 1){
        //   // this.pageNum>1?this.pageNum--:this.pageNum =1
        // }else if(this.total%this.pageSize == this.selectData.length){
        //   // this.pageNum>1?this.pageNum--:this.pageNum =1
        // }
        if (this.total % this.pageSize === 1 || this.total % this.pageSize === this.selectData.length) {
          // this.pageNum>1?this.pageNum--:this.pageNum =1
          this.changepage();
        }
      }
      this.$refs["userManage-".concat(scope.row.id)].doClose();
      var data = [];
      data.push(scope.row.userId);
      this.$API.delRequest({
        url: '/platform/user',
        data: data
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this7.$message({
            message: '删除用户成功',
            type: 'success'
          });
          if (_this7.dataOrgId === '') {
            _this7.searchForm();
          } else {
            _this7.getCurrentNode(_this7.dataOrgId);
          }
        }
      });
    },
    // 删除最后一页页码回退一页
    changepage: function changepage() {
      this.pageNum > 1 ? this.pageNum-- : this.pageNum = 1;
    },
    configAdd: function configAdd() {
      this.orgErr = false;
      this.isshowdependOrg = false;
      this.editPermisiongForm.userName = this.configUserId.row.userName;
      this.editPermisiongForm.userId = this.configUserId.row.userId;
      this.editPermisiongForm.roleName = '';
      this.editPermisiongForm.roleId = '';
      this.editPermisiongForm.corner = 'A';
      this.editPermisiongForm.orgPathName = [];
      this.editPermisiongForm.systemId = '';
      this.editPermisiongForm.id = '';
      this.configTitle = '新增权限配置';
      this.editPermissions = true;
    },
    getRoleId: function getRoleId(role) {
      this.editPermisiongForm.roleId = role.roleId;
    },
    subEditPermissions: function subEditPermissions() {
      var _this8 = this;
      if (this.isshowdependOrg && this.editOrgPath.length === 0) {
        this.orgErr = true;
        this.$message({
          message: '请完善信息填写',
          type: 'warning'
        });
        return;
      }
      this.editPermisiongForm.orgPathName = this.editOrgPath;
      this.$refs.editPermissionForm.validate(function (valid) {
        if (valid) {
          var data = {};
          // eslint-disable-next-line guard-for-in
          for (var i in _this8.editPermisiongForm) {
            data[i] = _this8.editPermisiongForm[i];
          }
          data.roleOrgId = [];
          _this8.editOrgPath.forEach(function (ele) {
            data.roleOrgId.push({
              orgId: ele
            });
          });
          data.roleName = data.roleId;
          _this8.$API.putRequest({
            url: '/platform/user/userRole',
            data: data
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this8.showConfig(_this8.configUserId);
              _this8.editPermissions = false;
            }
          });
        } else {
          _this8.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
      // if(this.editPermisiongForm.corner == ''){
      //   this.$message({
      //     message:'请选择用户角色',
      //     type:"warning"
      //   })
      //   return
      // }
    },
    changeSystemId: function changeSystemId(systemId) {
      var _this9 = this;
      this.editPermisiongForm.roleName = '';
      this.editPermisiongForm.roleId = '';
      this.$API.getRequest({
        url: "/platform/role/systemId/".concat(systemId),
        data: {
          systemId: systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this9.roleList = res.result;
        }
      });
    },
    configEdit: function configEdit(data) {
      var _this10 = this;
      this.isshowdependOrg = false;
      this.configTitle = '编辑用户角色权限配置';
      this.editPermisiongForm.userName = this.configUserId.row.userName;
      this.editPermisiongForm.userId = this.configUserId.row.userId;
      this.editPermisiongForm.roleName = data.row.roleName;
      this.editPermisiongForm.roleId = data.row.roleId;
      this.editPermisiongForm.id = data.row.id;
      this.editPermisiongForm.corner = data.row.corner;
      data.row.roleOrgList.forEach(function (res) {
        _this10.editOrgPath.push(res.orgId);
      });
      this.editPermisiongForm.systemId = data.row.systemId;
      if (data.row.systemId !== '') {
        this.$API.getRequest({
          url: "/platform/role/systemId/".concat(data.row.systemId),
          data: {
            systemId: data.row.systemId
          }
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this10.roleList = res.result;
            _this10.roleList.forEach(function (ele) {
              if (ele.roleId === data.row.roleId && ele.dependOrg === 1) {
                _this10.isshowdependOrg = true;
              }
            });
          }
        });
      }
      this.editPermissions = true;
    },
    configDelete: function configDelete(scope) {
      var _this11 = this;
      this.$API.delRequest({
        url: "/platform/user/role/".concat(scope.row.id)
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this11.showConfig(_this11.configUserId);
        }
      });
    },
    remoteMethod: function remoteMethod(query) {
      var _this12 = this;
      this.loading = true;
      this.$API.getRequest({
        url: '/platform/org/geOrgByLikeOrgName',
        data: {
          patternKey: query,
          pageSize: 10,
          pageNum: 1
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this12.orgDialogOptions = res.result;
          _this12.loading = false;
        }
      });
    },
    changeOrg: function changeOrg(data) {
      this.orgDialogOptions = [];
      this.orgSelectList = '';
      this.orgDialogValue = '';
      this.$refs["userManage-".concat(data.row.id)].doClose();
      this.changeOrgData = data;
      this.userOrgChange = false;
      this.showOrgDialog = true;
    },
    sync: function sync() {},
    submitAddUser: function submitAddUser() {
      var _this13 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this13.newUserInfo.pathName = _this13.orgSelectList;
          _this13.$API.postRequest({
            url: '/platform/user',
            data: _this13.newUserInfo
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this13.showAddUserDialog = false;
              // this.searchForm();
              _this13.$message({
                message: '新增成功',
                type: 'success'
              });
              _this13.pageshow = false;
              _this13.pageNum = _this13.total % _this13.pageSize === 0 ? Math.ceil(_this13.total / _this13.pageSize) + 1 : Math.ceil(_this13.total / _this13.pageSize);
              _this13.searchForm();
              _this13.$nextTick(function () {
                _this13.pageshow = true;
              });
            }
          });
        } else {
          _this13.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    },
    submitEditInfo: function submitEditInfo() {
      var _this14 = this;
      this.$refs.editInforuleForm.validate(function (valid) {
        if (valid) {
          _this14.$API.putRequest({
            url: '/platform/user',
            data: _this14.editInfo
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this14.$message({
                message: '修改用户信息成功',
                type: 'success'
              });
              _this14.showUserDialog = false;
              _this14.searchForm();
            }
          });
        } else {
          _this14.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    },
    editUserInfo: function editUserInfo(scope) {
      this.$refs["userManage-".concat(scope.row.id)].doClose();
      window.open(decodeURIComponent("".concat(window.location.origin, "/system/addUser?userId=").concat(scope.row.userId, "&isEdit=1")));
      // this.$refs[`userManage-`+scope.row.id].doClose()
      // this.manageList = []
      // this.editInfo = JSON.parse(JSON.stringify(scope.row));
      // let jobName = []
      // this.editInfo.jobList.forEach((ele)=>{
      //   jobName.push(ele.jobName+'/'+ele.jobCode)
      // })
      // this.$set(this.editInfo,'jobCodeList',jobName)
      // this.showUserDialog = true
    },
    showConfig: function showConfig(data) {
      var _this15 = this;
      this.$refs["userManage-".concat(data.row.id)].doClose();
      this.configUserId = data;
      this.systemId = '';
      this.roleName = '';
      this.DialogSystemName = '';
      this.$API.getRequest({
        url: '/platform/user/role',
        data: {
          userId: data.row.userId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this15.configureData = res.result.userRoleVOList;
          _this15.resourceVOList = res.result.resourceVOList;
          if (res.result.userRoleVOList !== null) {
            res.result.userRoleVOList.forEach(function (ele, index) {
              var OrgNameList = '';
              ele.roleOrgList.forEach(function (child) {
                OrgNameList += ",".concat(child.orgName);
              });
              _this15.configureData[index].orgPathName = OrgNameList.substring(1, OrgNameList.length);
            });
          }
          _this15.userSettingName = "".concat(data.row.userName, "/").concat(data.row.userId);
          _this15.showSetting = true;
        }
      });
    },
    resetConfig: function resetConfig() {
      var _this16 = this;
      this.DialogSystemName = '';
      this.DialogRoleName = '';
      this.$API.getRequest({
        url: '/platform/user/role',
        data: {
          userId: this.configUserId.row.userId,
          systemId: this.DialogSystemName,
          roleName: this.DialogRoleName
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this16.configureData = res.result.userRoleVOList;
          _this16.permissionList = res.result;
          var OrgNameList = '';
          _this16.resourceVOList = res.result.resourceVOList;
          if (res.result.userRoleVOList !== null) {
            res.result.userRoleVOList.forEach(function (ele, index) {
              ele.roleOrgList.forEach(function (child) {
                OrgNameList += ",".concat(child.orgName);
              });
              _this16.configureData[index].orgPathName = OrgNameList.substring(1, OrgNameList.length);
            });
          }
          _this16.userSettingName = "".concat(_this16.configUserId.row.userName, "/").concat(_this16.configUserId.row.userId);
          _this16.showSetting = true;
        }
      });
    },
    searchConfig: function searchConfig() {
      var _this17 = this;
      this.fingureLoading = true;
      this.$API.getRequest({
        url: '/platform/user/role',
        data: {
          userId: this.configUserId.row.userId,
          systemId: this.DialogSystemName,
          roleName: this.DialogRoleName
        }
      }).then(function (res) {
        _this17.fingureLoading = false;
        if (res.code === '0000000000') {
          // this.fingureLoading = false
          _this17.configureData = res.result.userRoleVOList;
          _this17.permissionList = res.result;
          var OrgNameList = '';
          _this17.resourceVOList = res.result.resourceVOList;
          if (res.result.userRoleVOList !== null) {
            res.result.userRoleVOList.forEach(function (ele, index) {
              ele.roleOrgList.forEach(function (child) {
                OrgNameList += ",".concat(child.orgName);
              });
              _this17.configureData[index].orgPathName = OrgNameList.substring(1, OrgNameList.length);
            });
          }
          _this17.userSettingName = "".concat(_this17.configUserId.row.userName, "/").concat(_this17.configUserId.row.userId);
          _this17.showSetting = true;
        }
      });
    },
    showUserInfo: function showUserInfo(data) {
      this.$refs["userManage-".concat(data.row.id)].doClose();
      // this.$router.push({
      //   path: '/system/addUser',
      //   query: {
      //     userId: data.row.userId,
      //     isCheck: 1,
      //   },
      // });
      window.open(decodeURIComponent("".concat(window.location.origin, "/system/addUser?userId=").concat(data.row.userId, "&isCheck=1")));
      // this.showUser = true
    },
    saveOrgId: function saveOrgId(data) {
      this.dataOrgId = data;
      this.pageNum = 1;
      this.getCurrentNode(data);
    },
    getCurrentNode: function getCurrentNode(data) {
      var _this18 = this;
      this.showTable = true;
      this.$API.getRequest({
        url: '/platform/user/org/orgId',
        data: {
          orgId: data.orgId,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      }).then(function (res) {
        _this18.showTable = false;
        _this18.tableData = res.result.records;
        _this18.tableData.forEach(function (ele, index) {
          _this18.tableData[index].pathName = ele.pathName == null || ele.orgId == null ? '' : "".concat(ele.pathName, "/").concat(ele.orgId);
        });
        _this18.total = res.result.total;
      });
    },
    searchForm: function searchForm() {
      var _this19 = this;
      this.showTable = true;
      this.$API.getRequest({
        url: '/platform/user/userIdAndUserName',
        data: {
          userId: this.userManageId.trim(),
          userName: this.userManageName.trim(),
          userStatus: this.userStatus,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      }).then(function (res) {
        _this19.showTable = false;
        if (res.code === '0000000000') {
          // this.showTable = false
          _this19.tableData = res.result.records;
          _this19.tableData.length > 0 && _this19.tableData.forEach(function (ele, index) {
            _this19.tableData[index].pathName = "".concat(ele.pathName, "/").concat(ele.orgId);
          });
          _this19.total = res.result.total;
        }
      });
    },
    resetForm: function resetForm() {
      this.userManageName = '';
      this.userManageId = '';
      this.userStatus = 'VALID', this.$refs.tree.setCurrentKey(null);
      this.dataOrgId = '';
      this.searchForm();
    },
    addTable: function addTable() {
      // this.$router.push({
      //   path: '/system/addUser',
      //   query: {
      //     isAdd: 1,
      //   },
      // });
      window.open(decodeURIComponent("".concat(window.location.origin, "/system/addUser?isAdd=1")));
    },
    loadNode: function loadNode(node, resolve) {
      var _this20 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(node.level === 0)) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", resolve(_this20.dataTree));
              case 4:
                _context.next = 6;
                return _this20.getTreeList({
                  depth: node.data.depth + 1,
                  orgId: node.data.orgId
                });
              case 6:
                resolve(JSON.parse(JSON.stringify(_this20.testArr)));
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getTreeList: function getTreeList(item) {
      var _this21 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // let id = item.orgId;
                // if (item.orgId && item.orgId.length > 6) {
                //   const idArr = item.orgId.split('/');
                //   id = idArr[idArr.length - 1];
                // }
                params = {
                  orgId: item.orgId,
                  orgStatus: 'VALID'
                };
                _context2.next = 3;
                return _this21.$API.getRequest({
                  url: '/platform/org/getChildOrg',
                  data: params
                }).then(function (res) {
                  if (!item.orgId) {
                    _this21.dataTree = res.result;
                  } else {
                    _this21.testArr = res.result;
                    _this21.requestOver = true;
                  }
                  if (item.depth === 1) {
                    // 显示所有数组
                    if (_this21.selectdOrgArr.length > 0) {
                      // 表示页面有默认选中值
                      setTimeout(function () {
                        _this21.setSelectedStatus(res.result);
                      }, 0);
                    }
                  }
                });
              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getInit: function getInit() {
      var _this22 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this22.dataTree = [];
                _context3.next = 3;
                return _this22.$API.getRequest({
                  url: '/platform/org/firstOrgs',
                  data: {
                    orgStatus: 'VALID'
                  }
                }).then(function (res) {
                  if (res.code === '0000000000') {
                    res.result.records.forEach(function (ele) {
                      _this22.openList.push(ele.pathId);
                    });
                    _this22.dataTree = res.result.records;

                    // this.getCurrentNode(this.dataTree[0])
                  }
                });
              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getOrgSelect: function getOrgSelect(node) {
      this.newUserInfo.orgId = node.orgId;
      this.newUserInfo.pathName = node.pathName;
      this.orgSelectList = node.pathName;
      this.selectNode = node;
    },
    // tooltips
    // 如果过长换行(length 32换行)
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    // 编辑用户信息确认
    confirmsureedite: function confirmsureedite(bool) {
      if (bool) {
        this.submitEditInfo();
      }
    },
    // 添加用户信息确认
    confirmsureadd: function confirmsureadd(bool) {
      if (bool) {
        this.submitAddUser();
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    }
  }
};